import { type FeatureCardStandardProps } from './FeatureCardStandard.types';
import FeatureCardMain from '../FeatureCardMain';
import FeatureCardImage from '../FeatureCardImage';

const FeatureCardStandard: React.FC<FeatureCardStandardProps> = ({
  imageLink,
  imagePosX,
  imagePosY,
  title,
  showTitle,
  smallHeading,
  date,
  content,
  imageStyle,
  hideImageOnMobile,
  formatOrder,
  linkText,
  linkExternal,
  linkInternal,
}) => (
  <div
    className={`feature-card test-class 
      ${formatOrder === 'Image right' ? 'feature-card--row-reverse' : ''} 
      ${hideImageOnMobile ? 'feature-card--image-hidden' : ''}`}
  >
    <FeatureCardImage
      imageStyle={imageStyle}
      imageLink={imageLink}
      imagePosX={imagePosX}
      imagePosY={imagePosY}
      hideOnMobile={hideImageOnMobile}
    />

    <FeatureCardMain
      showTitle={showTitle}
      title={title}
      content={content}
      linkText={linkText}
      linkExternal={linkExternal}
      linkInternal={linkInternal}
      date={date}
      smallHeading={smallHeading}
    />
  </div>
);

export default FeatureCardStandard;
